/**
 * Adjust layout
 *
 */
function adjustLayout() {
  // Move scroll up button up
  if (document.querySelector('#scroll-up-btn')) document.querySelector('#scroll-up-btn').classList.add('move-up');
  // Add spacing below footer
  document.querySelector('body').style.paddingBottom = `${document.querySelector('.at-sticky-atc').clientHeight}px`;
}

/**
 * Show atc after scrolling past main atc button
 *
 */
function addScrollBehavior() {
  const header = document.querySelector('.shopify-section-header-sticky');
  if (!header) return;
  const headerHeight = header.offsetHeight;
  /**
   * @param {HTMLElement[]} entries DOM nodes
   */
  const handleIntersection = (entries) => {
    entries.forEach((entry) => {
      const stickyWrapper = document.querySelector('.at-sticky-atc');
      if (entry.isIntersecting) {
        stickyWrapper.classList.remove('at-show');
      } else if (entry.boundingClientRect.top - headerHeight < 0) stickyWrapper.classList.add('at-show');
    });
  };
  const observer = new IntersectionObserver((entries) => handleIntersection(entries), {
    root: null,
    threshold: 0,
    rootMargin: `-${headerHeight}px 0px 0px 0px`,
  });
  [document.querySelector('.product-form-block__wrapper')].forEach((section) => observer.observe(section));
}

/**
 * Init
 *
 */
function init() {
  addScrollBehavior();
  adjustLayout();
}

init();

/**
 * Sync quantity inputs between main form and sticky ATC
 */
function syncQuantityInputs() {
  const mainQuantityInput = document.querySelector('.product-form-block__wrapper quantity-input input');
  const stickyQuantityInput = document.querySelector('.at-sticky-atc quantity-input input');

  if (!mainQuantityInput || !stickyQuantityInput) return;

  // Sync sticky -> main
  stickyQuantityInput.addEventListener('change', () => {
    mainQuantityInput.value = stickyQuantityInput.value;
    mainQuantityInput.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // Sync main -> sticky
  mainQuantityInput.addEventListener('change', () => {
    stickyQuantityInput.value = mainQuantityInput.value;
  });
}

document.addEventListener('DOMContentLoaded', () => {
  const stickyForm = document.querySelector('.at-sticky-atc form');
  if (!stickyForm) return;

  stickyForm.addEventListener('submit', () => {
    window.lastAddedSource = 'product-page';
  });

  syncQuantityInputs();
});
